'use strict'
import Config from '../../config';

/**
 * View for component Navbar
 * @returns html to view navbar block
 */

class View {
    appendNav() {

        const view = /* html */
            ` 
        <div class="w-full border-b border-gray-300">
        <div class="container mx-auto">
            <nav class="relative flex flex-wrap items-center justify-between py-3">
                
                <div class="px-4 mx-auto flex-wrap items-center justify-between mb-2 ml-2 hidden sm:flex">
                    
                    <div class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
                    
                        <a href="${Config.siteUrl}" class="flex items-center">
                            <img src="/static/images/brain_blue.svg" alt="face-splash" class="mr-3 h-6 sm:h-9">                                                            
                                <span id="_title"></span>                                                                
                        </a>
                    </div>                    
                </div>
                
                <div class="container px-4 flex items-center justify-between">                
                    
                <ul id="navbarLinks" class="flex lg:flex-row list-none lg:ml">
                    
                        <li class="nav-item">
                            <a 
                                id="nav-home" 
                                navigateLinkTo="/"
                                class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug opacity-75 cursor-pointer">
                                Home
                            </a>
                        </li>
                        <li class="nav-item">
                        
                            <a id="nav-about" 
                                navigateLinkTo="/about"                             
                                class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug opacity-75 cursor-pointer">
                                About
                            </a>

                        </li>
                        <li class="nav-item">
                            <a 
                                id="nav-articles"                             
                                navigateLinkTo="/articles"                            
                                class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug opacity-75 cursor-pointer">
                                Blog
                            </a>
                        </li>
                        <li class="nav-item">
                            <a 
                                id="nav-projects" 
                                navigateLinkTo="/projects"                            
                                class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug opacity-75 cursor-pointer">
                                Projects
                            </a>
                        </li>
                        <li class="nav-item hidden sm:flex ml-2 -mt-3.5 lg:-mt-3.5 lg:ml-0">
                            <a  href="${Config.socialLinks.github}"
                                class="sl_container github_no_touch">
                                <div class="sl_circle">
                                    <svg  preserveAspectRatio="xMinYMin meet" viewBox="0 0 200 200">
						                <circle cx="100" cy="100" r="50"/>
						            </svg>
                                    <div class="sl_social">
                                        <i class="bi bi-github"></i>
                                    </div>
                                </div>						        						        						        
					        </a>
                        </li>
                        <li class="nav-item hidden sm:flex ml-2 -mt-3.5 lg:-mt-3.5 lg:ml-0">
                            <a  href="${Config.socialLinks.linkedin}"
                                class="sl_container linkedin_no_touch">
                                <div class="sl_circle">
                                    <svg  preserveAspectRatio="xMinYMin meet" viewBox="0 0 200 200">
						                <circle cx="100" cy="100" r="50"/>
						            </svg>
                                    <div class="sl_social">
                                        <i class="bi bi-linkedin"></i>
                                    </div>
                                </div>
					        </a>
                        </li>                        
                        <li class="nav-item sm:flex ml-2 -mt-3.5 lg:-mt-3.5 lg:ml-0">
                            <a  id="theme-toggle" class="sl_container sun_no_touch">
                                <div class="sl_circle">
                                    <svg  preserveAspectRatio="xMinYMin meet" viewBox="0 0 200 200">
						                <circle cx="100" cy="100" r="50"/>
						            </svg>
                                    <div class="sl_social">                                        
                                        <i class="bi bi-brightness-high-fill"></i>
                                    </div>
                                </div>						        						        						        
					        </a>
                        </li>
                        <li class="nav-item flex pl-8 lg:pl-0 ml-2 lg:ml-3 items-center" style="align-self: center; margin-top: -3px;">
                            <input
                                id="nav-search"
                                type="text"
                                placeholder="search..."
                                autocomplete="off"
                                maxlength="50"
                                class="text-xs font-mono border border-slate-300 dark:border-slate-600 text-slate-500 dark:text-slate-400 placeholder-slate-400 dark:placeholder-slate-500 px-2 py-2 h-9 rounded-full bg-transparent focus:outline-none focus:border-blue-400 focus:text-blue-500 w-16 sm:w-20 lg:w-32 transition-all duration-300 focus:w-28 sm:focus:w-36 lg:focus:w-48"
                            />
                        </li>
                    </ul>                    
                </div>        
            </nav>
        </div>
        </div>
        `

        return view
    }
}

export default View